<template>
  <RemoteComponent component="Footer" />
</template>

<script>
import RemoteComponent from '@/components/RemoteComponent.vue'
export default {
   name: 'Footer',
   components: {
       RemoteComponent
   },
   data () {
       return {
       
       }
   },
   mounted () {
   
   },
   methods: {
      
   },
}
</script>
<style>
</style>